#import "../fragments/activity-for-modal-fragment.graphql"

mutation CreateActivityForModal($input: ActivityCreateInput!) {
    activityCreate(input: $input) {
        activity {
            ...ActivityModalFragment
        }
    }
}
